import { Observable } from 'rxjs/internal/Observable';
import { Dictionary } from '../model/reducer';
import { PatternType } from '../plugins/pattern-type.model';
import { Pattern } from '../patterns/pattern.model';
import { Project } from '../projects/project.model';
import { ResourceList } from '../patterns/pattern-attachment.model';
import { PropertyWidgetContextType } from './property-widget-context-type.enum';
import { ViewAttachmentFileDiffEvent } from '../projects/publish-project/pattern-diff-view/pattern-diff-data.model';

export class PropertyWidgetContext {
  type: PropertyWidgetContextType;
  patternTypes$: Observable<Dictionary<PatternType> | null>;
  currentProject$: Observable<Project | null>;
  patterns$: Observable<Map<string, Pattern>>;
  allPatternResources$: Observable<Dictionary<Dictionary<ResourceList>>>;

  public toggleDiffAttachmentResource(_viewDiffEvent: ViewAttachmentFileDiffEvent): void {/* only used in the publish context */}

}

